import React, { useState } from "react";

import ProfileCard from "components/ProfileCard";
import { isLoaded } from "helpers";
import { useSelector } from "hooks";
import { selectEventProfile } from "store/selectors";

import CompanyWindow from "./CompanyWindow";
import ProjectWindow from "./ProjectWindow";

export const maxWidth = 450;

const PreviewProfile = () => {
  const eventProfile = useSelector(selectEventProfile);
  const [isCompanyWindowOpen, setIsCompanyWindowOpen] =
    useState<boolean>(false);
  const [isProjectWindowOpen, setIsProjectWindowOpen] =
    useState<boolean>(false);

  return (
    <>
      <div style={{ margin: "auto", maxWidth }}>
        <ProfileCard
          isLoading={!isLoaded(eventProfile)}
          onBoothButtonClick={() => setIsCompanyWindowOpen(true)}
          onProjectButtonClick={() => setIsProjectWindowOpen(true)}
          user={eventProfile}
        />
      </div>
      <CompanyWindow
        companyId={eventProfile?.companyId}
        isOpen={isCompanyWindowOpen}
        onClose={() => setIsCompanyWindowOpen(false)}
      />

      <ProjectWindow
        user={eventProfile}
        isOpen={isProjectWindowOpen}
        onClose={() => setIsProjectWindowOpen(false)}
      />
    </>
  );
};

export default PreviewProfile;
